import {$window, $body} from '../Constants';
import HtmlElementsStack from '../Elements/HtmlElementsStack';

// import special HtmlElements
import Banner from '../Elements/Banner';
import Header from '../Elements/Header';
import MainMenu from '../Elements/MainMenu';
//import HorizontalSubMenu from '../Elements/HorizontalSubMenu';
//import MetaMenu from '../Elements/MetaMenu';
//import BackToTopButton from '../Elements/BackToTopButton';
import ContentSlider from '../Elements/ContentSlider';
import ImageSlider from '../Elements/ImageSlider';
//import Tiles from '../Elements/Tiles';
import Videos from '../Elements/Videos';
import ContactButton from '../Elements/ContactButton';
import CollapsibleContent from '../Elements/CollapsibleContent';
import ResultsheetOverview from '../Elements/ResultsheetOverview';
import Equipments from '../Elements/Equipments';
import Search from '../Elements/Search';

/**
 * Controller for this page
 * Handles page flow and special HtmlElements
 */
class PageController {

	constructor() {
		// Object containing special elements that inherit from HtmlElement
		// relevant page events are delegated to these objects through the controller
		this.htmlElementsStack = new HtmlElementsStack(
			Banner,
			Header,
			MainMenu,
			//HorizontalSubMenu,
			//BackToTopButton,
			//MetaMenu,
			ContentSlider,
			ImageSlider,
            //Tiles,
            Videos,
			ContactButton,
			CollapsibleContent,
			ResultsheetOverview,
            Equipments,
			Search
		);
	}

	onReady() {
		// pass ready event to HtmlElements
		this.onEvent('onReady');

		this.bindEventListeners();
		this.formatHeadlines();

		$("a[href*='#']").on('click', (e) => {
			let $target = $(e.currentTarget);
        	let hash = $target.attr('href').split('#')[1];

        	if(hash.length > 0) {
        		let $el = $('#' + hash);
                e.preventDefault();

        		if($el.length == 1) {
        			this.scrollToElement($el);
				}
			}
		});

		this.reEqualizeBigTwoColumns();
	}

	onEvent(fn, e = {}) {
		// pass event to HtmlElements
		this.htmlElementsStack.forEachCallFunction(fn, e);
	}

	bindEventListeners() {
		$window.on({
			'load': e => {this.onEvent('onLoad', e)},
			'scroll': e => {this.onEvent('onScroll', e)},
			'resize': e => {this.onEvent('onResize', e)},
		});
	}

	formatHeadlines() {
        $body.find('h1').each(function() {
            if($(this).next('h2').length < 1 && $(this).next('h3').length < 1) {
                $(this).addClass('notNext');
            }
        });

		$body.find('h2').each(function() {
			if($(this).next('h3').length < 1 && $(this).next('h2').length < 1) {
				$(this).addClass('notNext');
			}
		});
	}

	scrollToElement($el) {
		let offset = $el.offset().top - Header.getHeight();

		$('html, body').animate({
			'scrollTop': offset
		}, 500);
	}

	reEqualizeBigTwoColumns() {
		$body.find('.bigTwoColumns').each(function() {
			let $row = $(this).find('> .row');

			function imageLoaded() {
				counter--;

				if(counter === 0) {
					$row.removeClass('equalized');
					new Foundation.Equalizer($row).applyHeight();
				}
			}

			let $images = $(this).find('img');
			let counter = $images.length;

			$images.each(function() {
				if(this.complete) {
					imageLoaded.call(this);
				} else {
					$(this).one('load', imageLoaded);
				}
			});
		});
	}
}

export default (new PageController);